"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixSchemaSimple = exports.defineSchemaSimple = exports.fixSchema = exports.defineSchema = exports.omitFuncText = exports.isObject = exports.isFunction = void 0;
exports.compileFunctions = compileFunctions;
exports.mergeSchema = mergeSchema;
exports.predefineSchema = predefineSchema;
exports.prefixSchema = prefixSchema;
exports.predefineSchemaSimple = predefineSchemaSimple;
exports.prefixSchemaSimple = prefixSchemaSimple;
exports.deepMergeSchema = deepMergeSchema;
exports.schemaToJsText = schemaToJsText;
const schemaMethods_1 = require("../schemaMethods");
const schemaFuncText_1 = require("./schemaFuncText");
// skopiowane z @vue/shared
/**
 * Sprawdza czy zmienna jest funkcją.
 * @param val
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
const isFunction = (val) => typeof val === 'function';
exports.isFunction = isFunction;
/**
 * Sprawdza czy zmienna jest obiektem.
 * @param val
 * @returns
 */
const isObject = (val) => val !== null && typeof val === 'object';
exports.isObject = isObject;
exports.omitFuncText = new Set([]);
const shortCalcFields = new Set([
    'enum',
    'calc',
    'fieldRequired',
    'readOnly',
    'disabled',
    'minimum',
    'maximum',
    'exclusiveMaximum',
    'exclusiveMinimum',
    'precision',
    'maxItems',
    'minItems',
    'maxLength',
    'minLength'
]);
/**
 * Kompiluje funkcje ale omija items i pojedyncze properties.
 * @param schema schemat
 * @returns
 */
function compileFunctions(schema, options = {}) {
    if (schema.$alreadyCompiled)
        return schema;
    for (const key in schema) {
        const keyValue = schema[key];
        switch (key) {
            case '$ref':
                // options.isRef = true;
                break;
            case '$external':
            case '$parent':
            case '$parent2':
            case '$parent3':
            case '$root':
                delete schema[key];
                break;
            case '$methods':
                if ((0, exports.isObject)(keyValue)) {
                    for (const methodName in keyValue) {
                        const method = keyValue[methodName];
                        if ((0, exports.isFunction)(method)) {
                            const mobj = {
                                body: (0, schemaFuncText_1.schemaFuncText)(method, { skipRemoveReturn: true, removeDebugger: options.removeDebugger })
                            };
                            // jeśli są atrybuty
                            if (method.length) {
                                const s = method.toString();
                                const p = s.indexOf('(');
                                if (p > -1) {
                                    const p2 = s.indexOf(')', p);
                                    mobj.args = s.substring(p + 1, p2);
                                }
                                keyValue[methodName] = mobj;
                            }
                            else {
                                keyValue[methodName] = mobj.body;
                            }
                        }
                    }
                }
                break;
            case '$on':
                if ((0, exports.isObject)(keyValue)) {
                    for (const methodName in keyValue) {
                        const method = keyValue[methodName];
                        const mobj = {
                            body: (0, schemaFuncText_1.schemaFuncText)(method, { skipRemoveReturn: true, removeDebugger: options.removeDebugger })
                        };
                        // jeśli są atrybuty
                        if (method.length) {
                            const s = method.toString();
                            const p = s.indexOf('(');
                            if (p > -1) {
                                const p2 = s.indexOf(')', p);
                                mobj.args = s.substring(p + 1, p2).split(',')[0]; //tylko pierwszy argument mnie interesuje
                            }
                        }
                        if (method.length == 1 && mobj.args == 'event') {
                            keyValue[methodName] = mobj.body;
                        }
                        else {
                            keyValue[methodName] = mobj;
                        }
                    }
                }
                break;
            case 'properties':
                if (schema.type !== 'object') {
                    delete schema[key];
                    schema.type = 'object';
                    schema[key] = keyValue;
                }
                for (const prop in keyValue) {
                    const propVal = keyValue[prop];
                    if ((0, exports.isFunction)(propVal)) {
                        const propValRes = propVal();
                        compileFunctions(propValRes, options);
                        keyValue[prop] = propValRes;
                    }
                    else if ((0, exports.isObject)(propVal)) {
                        compileFunctions(propVal, options);
                    }
                }
                break;
            case 'items':
                if (schema.type !== 'array') {
                    delete schema[key];
                    schema.type = 'array';
                    schema[key] = keyValue;
                }
                if ((0, exports.isFunction)(keyValue)) {
                    const itemsValRes = keyValue();
                    compileFunctions(itemsValRes, options);
                    schema[key] = itemsValRes;
                }
                else if ((0, exports.isObject)(keyValue)) {
                    compileFunctions(keyValue, options);
                }
                break;
            case 'pattern':
                if (keyValue instanceof RegExp) {
                    schema[key] = keyValue.source;
                    if (keyValue.flags != 'i') {
                        if (keyValue.flags == '') {
                            schema['patternFlags'] = null;
                        }
                        else {
                            schema['patternFlags'] = keyValue.flags;
                        }
                    }
                }
                else if ((0, exports.isFunction)(keyValue)) {
                    schema[key] = (0, schemaFuncText_1.schemaFuncText)(keyValue, {
                        skipRemoveReturn: true,
                        removeDebugger: options.removeDebugger
                    });
                }
                break;
            default:
                if ((0, exports.isFunction)(keyValue)) {
                    if (!exports.omitFuncText.has(key)) {
                        schema[key] = (0, schemaFuncText_1.schemaFuncText)(keyValue, {
                            skipRemoveReturn: !shortCalcFields.has(key),
                            removeDebugger: options.removeDebugger
                        });
                    }
                }
                else if ((0, exports.isObject)(keyValue)) {
                    if (key === 'allOf') {
                        // options.isAllOf = true;
                    }
                    compileFunctions(keyValue, options);
                }
        }
    }
    return schema;
}
/**
 * Kompiluje funkcje w schemacie i zaznacza zeby powtórnie go nie kompilować (użyteczne przy zagnieżdzaniu schematów ).
 * @param schema
 * @returns
 */
function compileFunctionsAndMark(schema) {
    /*
      var opts = {
          isRef: false,
          isAllOf: false
      }
      */
    const schema2 = compileFunctions(schema);
    Object.defineProperty(schema2, '$alreadyCompiled', {
        value: true,
        enumerable: false
    });
    return schema2;
}
function mergeSchema(...schemas) {
    return deepMergeSchema(schemas);
}
class PredefineSchema {
    constructor(root, external, methods, skipCompile) {
        if (skipCompile) {
            this.fixSchema = this.defineSchemaSimple;
            this.defineSchema = this.defineSchemaSimple;
        }
    }
    //@ts-ignore
    defineSchema(...schemas) {
        if (schemas.length == 1)
            return compileFunctionsAndMark(schemas[0]);
        return compileFunctionsAndMark(deepMergeSchema(schemas));
    }
    defineSchemaSimple(...schemas) {
        if (schemas.length == 1)
            return schemas[0];
        return deepMergeSchema(schemas);
    }
    fixSchema(...schemas) {
        return compileFunctionsAndMark(deepMergeSchema(schemas));
    }
}
/**
 * Predefinicja schematu, umożliwia ustawienie typu $root, $external i $methods.
 * @param $root
 * @param $external
 * @param $methods
 * @returns
 */
function predefineSchema($root, $external, $methods) {
    return new PredefineSchema($root || {}, $external || {}, $methods || {}, false).defineSchema;
}
/**
 * Definicja schematu bez typowania.
 */
exports.defineSchema = predefineSchema();
/**
 * Predefinicja funkcji fix która zmienia schemat bez zmiany zwracanego typu.
 * @param $root
 * @param $external
 * @param $methods
 * @returns
 */
function prefixSchema($root, $external, $methods) {
    return new PredefineSchema($root || {}, $external || {}, $methods || {}, false).fixSchema;
}
/**
 * Funkcja zmieniająca schemat bez zmiany typu.
 */
exports.fixSchema = prefixSchema();
/**
 * Predefinicja schematu bez kompilacji funkcji, umożliwia ustawienie typu $root, $external i $methods.
 * @param $root
 * @param $external
 * @param $methods
 * @returns
 */
function predefineSchemaSimple($root, $external, $methods) {
    return new PredefineSchema($root || {}, $external || {}, $methods || {}, true).defineSchema;
}
/**
 * Definicja schematu bez typowania i kompilacji funkcji.
 */
exports.defineSchemaSimple = predefineSchemaSimple();
/**
 * Predefinicja funkcji fix która zmienia schemat bez zmiany zwracanego typu i bez kompilacji funkcji.
 * @param $root
 * @param $external
 * @param $methods
 * @returns
 */
function prefixSchemaSimple($root, $external, $methods) {
    return new PredefineSchema($root || {}, $external || {}, $methods || {}, true).fixSchema;
}
/**
 * Funkcja zmieniająca schemat bez zmiany typu i kompilacji funkcji.
 */
exports.fixSchemaSimple = prefixSchemaSimple();
/**
 * Funkcja do głebokiego łączenia schematów.
 * @param items
 * @returns
 */
function deepMergeSchema(items) {
    const mergeProps = {};
    const res = {};
    // const starProps: any[] = [];
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        for (const key in item) {
            const value = item[key];
            if (key === '_' || key === '*') {
                // czy są określone pola jakich dotyczy łaczenie ?
                if (value.$fields) {
                    const starProps = [];
                    let starFields = value.$fields;
                    // jeśli funkcja to wykonać
                    if ((0, exports.isFunction)(starFields)) {
                        starFields = starFields.call(mergeProps);
                    }
                    if (Array.isArray(starFields)) {
                        for (let starItem of starFields) {
                            if (typeof starItem === 'string') {
                                starItem = mergeProps[starItem];
                            }
                            if (starItem)
                                starProps.push(starItem);
                        }
                    }
                    delete value.$fields;
                    for (const propArray of starProps) {
                        propArray.push(value);
                    }
                }
                else {
                    for (const key in mergeProps) {
                        const propArray = mergeProps[key];
                        propArray.push(value);
                    }
                }
            }
            else if (value === undefined) {
                delete mergeProps[key];
                delete res[key];
            }
            else if (key === 'default') {
                res[key] = value;
            } /* else if (value === null) {
                      delete mergeProps[key];
                      delete res[key];
                  } */
            else if (Array.isArray(value)) {
                delete mergeProps[key];
                res[key] = value;
            }
            else if ((0, exports.isFunction)(value)) {
                delete mergeProps[key];
                res[key] = value;
            }
            else if ((0, exports.isObject)(value)) {
                let propArray = mergeProps[key];
                if (propArray == undefined) {
                    propArray = [];
                    mergeProps[key] = propArray;
                }
                propArray.push(value);
            }
            else {
                delete mergeProps[key];
                res[key] = value;
            }
        }
    }
    /*
      let starProp = null;
      if (starProps.length) {
          if (starProps.length>1) {
              starProp = deepMergeSchema
          }
      }
      */
    for (const key in mergeProps) {
        const propArray = mergeProps[key];
        if (propArray.length == 1) {
            res[key] = propArray[0];
        }
        else {
            res[key] = deepMergeSchema(propArray);
        }
    }
    return res;
}
function _schemaToJsText(schemaDef) {
    const json = JSON.stringify(schemaDef, (key, value) => {
        if (typeof value === 'function') {
            return '[FUNCTION]' + value;
        }
        return value;
    }, '  ');
    let moduleJavascript = json.replace(/"(\[FUNCTION])?((?:\\.|[^\\"])*)"(:)?/g, (match, group1, group2, group3) => {
        if (group1)
            return JSON.parse('"FUNCTION' + group2 + '"');
        //if (group1) return JSON.parse('"' + group2 + '"');
        if (group3 && /^\w+$/.test(group2))
            return group2 + ':';
        return match;
    });
    //moduleJavascript = moduleJavascript.replace(/(\b\w+\b):\s*FUNCTION\1\s*\(/g, (match, group1) => {
    // add: FUNCTIONadd(    | add: FUNCTION(  |
    //moduleJavascript = moduleJavascript.replace(/(\b\w+\b):\s*FUNCTION(\1\s*|s*)\(/g, (match, group1) => {
    //add: FUNCTIONadd()  | add: FUNCTIONfunction add()
    moduleJavascript = moduleJavascript.replace(/(\b\w+\b):\s*FUNCTION(function\s)?\1\s*\(/g, (match, group1) => {
        if (group1)
            return group1 + '(';
        return match;
    });
    //add: FUNCTION() =>
    moduleJavascript = moduleJavascript.replace(/(\b\w+\b):\s*FUNCTION\s*\(/g, (match, group1) => {
        if (group1)
            return group1 + ': (';
        return match;
    });
    return moduleJavascript;
}
/**
 * Zamienia schemat na tekst JS.
 * @param schemaDef definicja schematu
 * @param replaceMethodsEnums czy zamieniać enumy z $methods na ich wartości
 * @returns
 */
function schemaToJsText(schemaDef, replaceMethodsEnums = true, removeThis = true) {
    const methodsEnums = {};
    const removedEnums = {};
    if (replaceMethodsEnums && schemaDef.$methods) {
        for (const key in schemaDef.$methods) {
            let isEnum = false;
            const val = schemaDef.$methods[key];
            if (!(0, exports.isFunction)(val)) {
                isEnum = true;
                if ((0, exports.isObject)(val)) {
                    for (const skey in val) {
                        const vval = val[skey];
                        if ((0, exports.isFunction)(vval) || (0, exports.isObject)(vval)) {
                            isEnum = false;
                        }
                        else {
                            methodsEnums[key + '.' + skey] = JSON.stringify(vval) + ' /* this.$methods.' + key + '.' + skey + ' */';
                        }
                    }
                }
                else {
                    // po prostu wartość
                    methodsEnums[key] = JSON.stringify(val) + ' /* this.$methods.' + key + ' */';
                }
            }
            if (isEnum) {
                removedEnums[key] = schemaDef.$methods[key];
                delete schemaDef.$methods[key];
            }
        }
        // usuniecie $methods ze schematu jeśli jest już jest puste
        if (Object.keys(schemaDef.$methods).length == 0) {
            delete schemaDef.$methods;
        }
    }
    let fixSimpleThis = false;
    if (removeThis) {
        if (!schemaDef.$options) {
            schemaDef.$options = {};
        }
        if (!schemaDef.$options.simpleThis) {
            schemaDef.$options.simpleThis = true;
            fixSimpleThis = true;
        }
    }
    let moduleJavascript = _schemaToJsText(schemaDef);
    if (replaceMethodsEnums) {
        // replace $methods enums for speed only
        for (const key in methodsEnums) {
            moduleJavascript = (0, schemaMethods_1.replaceAll)(moduleJavascript, 'this.$methods.' + key, methodsEnums[key]);
        }
        // restore removed $methods in schema
        for (const key in removedEnums) {
            if (!schemaDef.$methods) {
                schemaDef.$methods = {};
            }
            schemaDef.$methods[key] = removedEnums[key];
        }
    }
    if (removeThis) {
        moduleJavascript = moduleJavascript.replace(/this\.\$(methods|root|external|parent3|parent2|parent|model|obj|event|value)/g, (math, group1) => {
            return '$' + group1;
        });
        if (fixSimpleThis) {
            if (schemaDef.$options && schemaDef.$options.simpleThis) {
                delete schemaDef.$options.simpleThis;
                if (Object.keys(schemaDef.$options).length == 0) {
                    delete schemaDef.$options;
                }
            }
        }
    }
    return moduleJavascript;
}
exports.default = exports.defineSchema;
//# sourceMappingURL=defineSchema.js.map